// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vant from 'vant'
// import 'vant/lib/index.css'
import 'vant/lib/index.less'

// import 'vant/lib/icon/local.css' //本地
import router from './router'
import store from './store'
import * as Filters from './utils/filters'
import * as Utils from '@/utils/index'
import '@/assets/style/index.less'
import _ from 'lodash'
import lrz from 'lrz'
import CONST from '@/utils/const'
import request from '@/utils/request'

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()

Vue.config.productionTip = false

Vue.prototype['VUE_APP_BASE_API'] = process.env.BACKEND_API
Vue.prototype['CONST'] = CONST
Vue.prototype['Filters'] = Filters
Vue.prototype['Utils'] = Utils
Vue.prototype._ = _
Vue.prototype['lrz'] = lrz
Vue.prototype['$axios'] = request
Vue.prototype['$dateStart'] = new Date().getFullYear()+'-01'+'-01'


// 注册系统基础组件
const baseComponents = require.context(
  '@/components/base',
  false,
  /Base[\w-]+\.vue$/
)
baseComponents.keys().forEach((fileName) => {
  const config = baseComponents(fileName)
  const name = Vue.prototype._.camelCase(
    fileName.replace(/^\.\/_/, '').replace(/\.\w+$/, '')
  )
  Vue.component(name, config.default || config)
})

const msg = (type, info) => {
  Vue.prototype.$notify({ type: type, message: info })
}
Vue.prototype['success'] = (info) => {
  msg('success', info)
}
Vue.prototype['warning'] = (info) => {
  msg('warning', info)
}
Vue.prototype['info'] = (info) => {
  msg('primary', info)
}
Vue.prototype['error'] = (info) => {
  msg('danger', info)
}

Vue.prototype['toast'] = (info) => {
  Vue.prototype.$toast(info)
}

Vue.prototype['alert'] = (info) => {
  return new Promise(((resolve, reject) => {
    Vue.prototype.$dialog.alert({
      title: CONST.TIP.TITLE,
      message: info
    }).then(() => {
      resolve()
    })
  }))
}

Vue.prototype['confirm'] = (info) => {
  return new Promise(((resolve, reject) => {
    Vue.prototype.$dialog.confirm({
      title: CONST.TIP.TITLE,
      message: info
    }).then(() => {
      resolve()
    }).catch(() => {
      reject()
    })
  }))
}

// register global utility filters
Object.keys(Filters).forEach(key => {
  Vue.filter(key, Filters[key])
})

Vue.use(Vant)

/* eslint-disable no-new */
let vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js